<template>
  <div class="app-body">
    <div class="app-body__content">
      <slot />
    </div>
    <div v-if="submitting" class="app-body__submitting">
      <b-loading active :is-full-page="false" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    submitting: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.app-body {
  display: flex;
  position: relative;
  height: calc(100% - #{$app-header-height});

  &__content {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &__submitting {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
